import { enhanceOptionsSchemaWithDynamicOptions, getPattern } from '../utils';

export const rectangleOptionsSchema = enhanceOptionsSchemaWithDynamicOptions({
    fillColor: {
        default: '> themes.defaultFillColor',
        description:
            'Specify the fill color. You may use a dataSource to apply the color. The hex value format should be "#FFFFFF". The default for enterprise light mode is "#C3CBD4". The default for enterprise dark mode is "#31373E". The default for prisma dark mode is "#0B0C0E".',
        type: 'string',
    },
    fillOpacity: {
        description:
            'Specify the opacity of the fill. Choose a number in the range of 0 - 1 (inclusive). You can also express the value as a percentage. For example, "0.80" in source or "80%" in UI.',
        type: 'number',
        default: 1,
    },
    rx: {
        description:
            'Specify the curvature of the horizontal corner (or border) radius with an integer or a percent greater than or equal to zero.',
        type: 'number',
        default: 0,
    },
    ry: {
        description:
            'Specify the curvature of the vertical corner (or border) radius with an integer or a percent greater than or equal to zero.',
        type: 'number',
        default: '> rx',
    },
    strokeColor: {
        default: '> themes.defaultStrokeColor',
        description:
            'Specify the stroke color. You may use a dataSource to apply the color. The hex value format should be "#FFFFFF". The default for enterprise light mode is "#3C444D". The default for enterprise dark mode is "#C3CBD4". The default for prisma dark mode is "#ACACAD".',
        type: 'string',
    },
    strokeDashStyle: {
        description:
            'Specify the size, in pixels, of dashes and spaces used to create a custom stitched outline. The value you specify applies to both the dashes and the spaces between them.',
        type: 'number',
        default: 0,
    },
    strokeJoinStyle: {
        description: 'Specifies the shape to be used at the corners of paths when they are joined.',
        type: 'string',
        default: 'miter',
        pattern: getPattern(['arcs', 'bevel', 'miter', 'miter-clip', 'round']),
    },
    strokeOpacity: {
        description:
            'Specify the opacity of the stroke. Choose a number in the range of 0 - 1 (inclusive). You can also express the value as a percentage. For example, "0.80" in source or "80%" in UI.',
        type: 'number',
        default: 1,
    },
    strokeWidth: {
        description: 'Specify the width of the stroke, in pixels. The minimum value is 0.',
        type: 'number',
        default: 1,
    },
});
